import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LogObject} from './log-object';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {RoutesRecognized} from '@angular/router';
import {DescriptorEnum} from '../config/descriptors/descriptor.enum';
import {ObjectType} from './object-type.enum';

@Injectable({
  providedIn: 'root',
})
export class LogRoutingService {

  postUrl: string;
  private baseUrl ="logApiUrl";

  previousUrl: string = null;

  constructor(private http: HttpClient) {
    this.postUrl = this.baseUrl + '/omnis/stat/log';
  }

  /**
   * Creates POST request with routing info if destination url aim to details.
   * @param {RoutesRecognized[]} e it needs to be array with length > = 2
   */
  addLog(e: RoutesRecognized) {
    const nextUrl = e.url;
    this.resolveParameters(nextUrl);

  }

  /**
   * Creates http post request, used to pass info about user route
   * @param {LogObject} logObject user route info
   * @returns {Observable<any>}
   */
  saveLog(logObject: LogObject): Observable<any> {
    return this.http.post<LogObject>(this.postUrl, logObject);
  }

  private resolveParameters(nextUrl: string) {

    const logObject = new LogObject();
    let target: string;

    if (!this.previousUrl) {
      logObject.source = 'url';
    } else {
      logObject.source = LogRoutingService.resolveActionSource(this.previousUrl, LogRoutingService.isSuggestion(nextUrl));
      if(!logObject.source) {
        logObject.source = this.previousUrl;
      }
    }
    target = LogRoutingService.resolveActionSource(nextUrl, false);

    if(this.previousUrl !== nextUrl) {
      this.previousUrl = nextUrl;

      if (target in ObjectType) {
        logObject.objectType = <ObjectType>ObjectType[target];
        logObject.objectId = LogRoutingService.getId(nextUrl);
        logObject.httpHeaders = '';
        console.debug('logging ' + nextUrl + ': ' + logObject);
        // this.saveLog(logObject).subscribe();
      }
    } else {
      console.debug('duplicate, ignoring:  ' + nextUrl);
    }
  }

  static resolveActionSource(url: string, isSuggestion: boolean): string {
    if (url) {
      if (isSuggestion) {
        return 'suggestions';
      } else {
        if(url.match('collectionId.*')){
          return 'collectionId';
        }
        if(url.match('\/collections.*')){
          return 'collections';
        }
        if(url.match('\/queries.*')){
          return 'queries';
        }
        if(url.match('\/collection')){
          return 'collection';
        }
        if(url.match('\/account')){
          return 'account';
        }
        if (url.match('\/search/s.*')) {
          return 'search';
        }
        if (url.match('\/search/b.*')) {
          return 'browse';
        }
        if (url.match('\/work\/.+')) {
          return 'work';
        }
        if (url.match('\/detail\/.+\/.+')) {
          return url.split('/')[2];
        }
        if (url.match('\/museum_object\/.+')) {
          return 'museum_object';
        }
        if (url.match('\/archive_object\/.+')) {
          return 'archive_object';
        }
        if (url.match('\/materialization\/.+')) {
          return 'materialization';
        }
        if(url ==='/' || url ==='/?root=true') {
          return 'url';
        }
        if(LogRoutingService.isInfoPage(url)){
          return 'info_page';
        }
        if (url.match('\/institutions')) {
          return 'institutions';
        }
        if (url.match('\/sitemap')) {
          return 'sitemap';
        }
        if (url.match('\/sparql-endpoint')) {
          return 'sparql';
        }
        if (url.match('\/login')) {
          return 'login';
        }
        if (url.match('\/register')) {
          return 'register';
        }
        if (url.match('\/reset-password')) {
          return 'reset_password';
        }
        else if (url.match('\/.+\/.+')) {
          const beginOfTheString = url.split('/')[1];
          if (beginOfTheString === DescriptorEnum.PERSONAL
          || beginOfTheString === DescriptorEnum.GEOGRAPHICAL
          || beginOfTheString === DescriptorEnum.CORPORATE
          || beginOfTheString === DescriptorEnum.EVENT
          || beginOfTheString === DescriptorEnum.GENRE
          || beginOfTheString === DescriptorEnum.SUBJECT) {
            return 'descriptor_object';
          }
        }
      }
      return null;
    }
  }

  private static isSuggestion(url: string): boolean {
    if(url) {
    return url.localeCompare('/') == 0 || (url.search('suggestion=true') > 0);
    } return false;
  }

  public static isInfoPage(url: string): boolean {
    if(url){
    return url.match('\/info\/.+') !== null;
    }
    return false;
  }

  private static getId(url: string): string {
    const values = url.split('/');
    const lastPart = values[values.length - 1];
    const rawNumber = lastPart.split('\?');

    return rawNumber[0];
  }

}
